import { get } from 'svelte/store';
import {
	EARN_API_URL_DEFAULT,
	MATCHA_0X_API_KEY,
	REFERRAL_API_URL,
	TRADE_STATS_STAGING_API_URL
} from './constants';
import { apiURL, tradeStatsApiURL } from '$lib/apis/store';
import { page } from '$app/stores';

const MATCHA_CALLDATA_API = 'https://optimism.api.0x.org';
const ARBITRAGE_API = 'https://arbitrage.polynomial.fi';

export function get_pyth_url() {
	if (get(page).url.hostname === 'trade.polynomial.fi')
		return 'https://polynomi-pyth-a46d.mainnet.pythnet.rpcpool.com';
	return 'https://hermes.pyth.network';
}

export async function api(method: string, resource: string, data?: Record<string, unknown>) {
	const api = get(apiURL);
	return await fetch(`${api}/${resource}`, {
		method,
		headers: {
			'content-type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		},
		body: data && JSON.stringify(data)
	});
}

export async function api_ssr(
	fetch: any,
	method: string,
	resource: string,
	data?: Record<string, unknown>
) {
	const api = get(apiURL);
	return await fetch(`${api}/${resource}`, {
		method,
		headers: {
			'content-type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		},
		body: data && JSON.stringify(data)
	});
}

export async function api_earn(method: string, resource: string, data?: Record<string, unknown>) {
	return await fetch(`${EARN_API_URL_DEFAULT}/${resource}`, {
		method,
		headers: {
			'content-type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		},
		body: data && JSON.stringify(data)
	});
}

export async function api_trade_stats(
	method: string,
	resource: string,
	data?: Record<string, unknown>
) {
	const api: string = get(tradeStatsApiURL);
	return await fetch(`${api}/${resource}`, {
		method,
		headers: {
			'content-type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		},
		body: data && JSON.stringify(data)
	});
}

export async function api_trade_stats_staging(
	method: string,
	resource: string,
	data?: Record<string, unknown>
) {
	return await fetch(`${TRADE_STATS_STAGING_API_URL}/${resource}`, {
		method,
		headers: {
			'content-type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		},
		body: data && JSON.stringify(data)
	});
}

export async function api_pyth(method: string, resource: string, data?: Record<string, unknown>) {
	const PYTH_URL = get_pyth_url();
	return await fetch(`${PYTH_URL}/api/${resource}`, {
		method,
		headers: {
			'content-type': 'application/json'
		},
		body: data && JSON.stringify(data)
	});
}

export async function api_pyth_ssr(
	fetch: any,
	method: string,
	resource: string,
	data?: Record<string, unknown>
) {
	const PYTH_URL = 'https://hermes.pyth.network';
	return await fetch(`${PYTH_URL}/api/${resource}`, {
		method,
		headers: {
			'content-type': 'application/json'
		},
		body: data && JSON.stringify(data)
	});
}

export async function api_matcha(method: string, resource: string) {
	return await fetch(`${MATCHA_CALLDATA_API}/${resource}`, {
		method,
		headers: {
			'0x-api-key': MATCHA_0X_API_KEY
		}
	});
}

export async function api_strategies(
	method: string,
	resource: string,
	data?: Record<string, unknown>
) {
	return await fetch(`${ARBITRAGE_API}/${resource}`, {
		method,
		headers: {
			'content-type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		},
		body: data && JSON.stringify(data)
	});
}

export async function api_strategies_ssr(
	fetch: any,
	method: string,
	resource: string,
	data?: Record<string, unknown>
) {
	return await fetch(`${ARBITRAGE_API}/${resource}`, {
		method,
		headers: {
			'content-type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		},
		body: data && JSON.stringify(data)
	});
}

export const api_referral = async (
	method: string,
	resource: string,
	data?: Record<string, unknown>
) => {
	return await fetch(`${REFERRAL_API_URL}/${resource}`, {
		method,
		headers: {
			'content-type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		},
		body: data && JSON.stringify(data)
	});
};
